import OrderHistory from './OrderHistory';

export default OrderHistory;


// WEBPACK FOOTER //
// ./src/components/OrderHistory/index.jsx